import styled from "styled-components";

export const ContainerSection = styled.div`
    border-radius: 100px 100px 0px 0px;
    background: #FFFFFF 0% 0% padding-box; 
    margin: 59px auto 0 auto;
    height: auto;
  
    
    @media (max-width: 700px) {
        border-radius: 0 0 0 0;
        max-width: 100%;
        margin: 3px auto 0 0;
        margin-left: 0px;
        margin-right: 8px;
        height: 100vh;
        background: #FFFFFF 0% 0% no-repeat padding-box; 
    }
`;

export const StepperStyleDesktop = styled.div`
    height: 100%;
    margin: 46px auto 0 auto;
    padding: 45px 0 0 0;
    width: 80%; 
    @media (max-width: 700px) {
        max-width: 100%;
        max-height: 100%
        padding: 0;
        height: 56px;
        width: 80%; 
      }
`;

export const StepperStyleLabel = styled.div`

    @media (max-width: 700px) {
        display:none;
      }
`;


export const ButtonStep = styled.div`
    margin-top: -46px;
    margin-left: 50px;
    font-weight: 400;
    font-size: 14px;
    color: #616161;
    display: flex;
    cursor:pointer;
    font-family: 'Open Sans', sans-serif;
    img{
        padding-right: 15px;
    }

    .ButtonStep{
        border: none;
        font-family: 'Open Sans',sans-serif;
        font-weight: 400;
        color: #616161;
        font-size: 14px;
        background: transparent;
        cursor:pointer;
        display:flex;
    }
`;
